// src/components/layout/TryNewDeckToast.js
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import {
    TRY_NEW_DECK_PATH,
    dismissTryNewToast,
    shouldShowTryNewToast
} from '../../utils/promoChrome';
import { usePageLeaveGuard } from './PageLeaveGuardContext';
import './TryNewDeckBanner.css';

function TryNewDeckToast() {
    const [visible, setVisible] = useState(() => shouldShowTryNewToast());
    const { navigate } = usePageLeaveGuard();

    if (!visible) return null;

    const handleTry = () => {
        navigate(TRY_NEW_DECK_PATH);
    };

    const handleDismiss = (event) => {
        event.preventDefault();
        event.stopPropagation();
        dismissTryNewToast();
        setVisible(false);
    };

    return (
        <div className="try-new-deck-toast" role="status" aria-live="polite">
            <button
                type="button"
                className="try-new-deck-toast-cta"
                onClick={handleTry}
            >
                <FontAwesomeIcon icon={faLayerGroup} className="try-new-deck-toast-icon" />
                <span className="try-new-deck-toast-copy">
                    <strong>Catalog Deck Builder</strong>
                    <span>Open the catalog page</span>
                </span>
            </button>
            <button
                type="button"
                className="try-new-deck-toast-close"
                onClick={handleDismiss}
                aria-label="Dismiss catalog Deck Builder toast"
            >
                ×
            </button>
        </div>
    );
}

export default TryNewDeckToast;
